// Mirrors server/Core/Pluspoint.Infrastructure/Tools/PostMessageTools.cs.
// Token catalog is owned by @constants/placeholders.js (POST context).

import { escapeRegex } from '@helpers/text-editor';

// U+E000 (Private Use Area), matching the C# EmptyValueMarker. Built from the codepoint
// to keep the source ASCII-only.
const EMPTY_MARKER = String.fromCharCode(0xe000);

const PUNCTUATION_AFTER_GAP = new Set(['\n', '\r', ',', '.', '!', '?', ';', ':']);

// Field map mirrors PostMessageTools.cs. [location]→locationName (not internalName) and
// [state]→region keep the preview byte-identical to publish-time output.
const fieldsFor = (location, brandTitle) => ({
    location: location?.locationName || '',
    brand: brandTitle || '',
    geomodifier: location?.geoModifier || '',
    primary_phone: location?.phoneNumber || '',
    email: location?.email || '',
    website: location?.website || '',
    address_line_1: location?.addressLine1 || '',
    address_line_2: location?.addressLine2 || '',
    city: location?.city || '',
    state: location?.region || '',
    postal_code: location?.postalCode || '',
    country: location?.country || '',
});

const TOKENS = Object.keys(fieldsFor({}, ''));
const TOKEN_REGEX = new RegExp(`\\[(${TOKENS.map(escapeRegex).join('|')})\\]`, 'g');
const EMPTY_RUN_REGEX = new RegExp(`[ \\t]*(${EMPTY_MARKER}[ \\t]*)+`, 'g');

export const resolveLocationPlaceholders = (text, location, brandTitle = '') => {
    if (!text || !location) return text || '';
    const values = fieldsFor(location, brandTitle);

    const substituted = text.replace(TOKEN_REGEX, (_, token) => values[token] || EMPTY_MARKER);
    if (!substituted.includes(EMPTY_MARKER)) return substituted;

    return substituted.replace(EMPTY_RUN_REGEX, (match, _g1, offset) => {
        const end = offset + match.length;
        if (offset === 0 || end === substituted.length) return '';
        if (PUNCTUATION_AFTER_GAP.has(substituted[end])) return '';
        const first = match[0];
        const last = match[match.length - 1];
        const padded = first === ' ' || first === '\t' || last === ' ' || last === '\t';
        return padded ? ' ' : '';
    });
};
